// test1150
(1150 && 0);
